import { Popover } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

function CustomTooltip({ type, text, children, placement = "top", button, show = true, ...props }) {
  if (!show || (!text && type !== "popover")) return <>{children}</>; // ⛔ Avoid rendering OverlayTrigger with null overlay

  let overlay;
  let trigger;
  let rootClose;

  if (type === "popover") {
    overlay = <Popover {...props}>{button}</Popover>;
    trigger = ["click"];
    rootClose = true;
  } else {
    overlay = (
      <Tooltip {...props}>
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </Tooltip>
    );
    trigger = ["hover", "focus"];
    rootClose = false;
  }

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 250, hide: 400 }}
      overlay={overlay}
      trigger={trigger}
      rootClose={rootClose}
    >
      <span tabIndex={0} style={{ display: "inline-block" }}>
        {children}
      </span>
    </OverlayTrigger>
  );
}

export default CustomTooltip;
